(function () {
  if (window.chickaguSkuSearch) return;

  var SKU_PATTERN = /^[A-Z0-9]+(?:-[A-Z0-9]+)+$/i;

  window.chickaguSkuSearch = {
    isSkuTerm: function (term) {
      var value = String(term || '').trim().replace(/\*+$/, '');
      return SKU_PATTERN.test(value) && /[A-Z]/i.test(value) && /\d/.test(value);
    },

    normalize: function (term) {
      var value = String(term || '').trim();
      if (!this.isSkuTerm(value) || /\*$/.test(value)) return value;
      return value + '*';
    },

    display: function (term) {
      var value = String(term || '').trim();
      if (!/\*$/.test(value)) return value;
      var withoutWildcard = value.replace(/\*+$/, '');
      return this.isSkuTerm(withoutWildcard) ? withoutWildcard : value;
    },

    isSearchForm: function (form) {
      if (!form || String(form.method || '').toLowerCase() !== 'get') return false;
      var action = form.getAttribute('action') || '';
      var searchPath = window.routes && window.routes.search_url ? window.routes.search_url : '/search';

      try {
        return new URL(action, window.location.origin).pathname === searchPath;
      } catch (error) {
        return action.indexOf('/search') !== -1;
      }
    }
  };

  // SKU ????? Shopify ???? *,?????????????????
  document.addEventListener('submit', function (event) {
    if (event.defaultPrevented) return;
    if (!window.chickaguSkuSearch.isSearchForm(event.target)) return;

    var input = event.target.querySelector('input[name="q"]');
    if (!input) return;

    var normalizedValue = window.chickaguSkuSearch.normalize(input.value);
    if (normalizedValue && normalizedValue !== String(input.value || '').trim()) {
      input.value = normalizedValue;
    }
  });

  // ????????????? SKU,??????? * ?????
  document.addEventListener('DOMContentLoaded', function () {
    var params = new URLSearchParams(window.location.search);
    var displayQuery = window.chickaguSkuSearch.display(params.get('q') || '');
    if (!displayQuery) return;

    document.querySelectorAll('input[type="search"][name="q"], form[action*="/search"] input[name="q"]').forEach(function (input) {
      if (window.chickaguSkuSearch.display(input.value) === displayQuery) {
        input.value = displayQuery;
      }
    });
  });
})();
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
